import { create } from "zustand";

interface SearchPanelStore {
  open: boolean;
  query: string;
  setOpen: (open: boolean) => void;
  setQuery: (query: string) => void;
  close: () => void;
}

export const useSearchPanelStore = create<SearchPanelStore>(set => ({
  open: false,
  query: "",
  setOpen: (open: boolean) => set({ open }),
  setQuery: (query: string) => set({ query }),
  close: () => set({ open: false, query: "" }),
}));
